import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext'; 
import { db } from '../firebaseConfig'; 
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import emailjs from '@emailjs/browser'; // Import EmailJS
import './BookNow.css';

const BookNow = () => {
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  const [formData, setFormData] = useState({
    destination: '',
    date: '',
    travelers: 1,
    name: '',
    email: '',
    phone: ''
  });

  useEffect(() => {
    if (currentUser) {
      setFormData(prev => ({
        ...prev,
        email: currentUser.email || '',
        name: (currentUser.firstName && currentUser.lastName) ? `${currentUser.firstName} ${currentUser.lastName}` : '' 
      }));
    }
  }, [currentUser]);

  const validateForm = () => {
    // Basic validation (simplified for brevity)
    if (!formData.destination || !formData.date || !formData.name || !formData.email) return false;
    return true;
  };

  const handleChange = (e) => {
    setFormData({...formData, [e.target.name]: e.target.value});
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
        setErrors({submit: "Please fill in all required fields"});
        return;
    }
    
    setIsSubmitting(true);
    setErrors({});

    try {
      // 1. Save to Firestore
      await addDoc(collection(db, "bookings"), {
        ...formData,
        travelers: Number(formData.travelers),
        userId: currentUser ? currentUser.uid : 'guest',
        status: 'pending',
        createdAt: serverTimestamp()
      });

      // 2. Send Email via EmailJS to yashpalmalawi870@gmail.com
      // REPLACE THESE WITH YOUR KEYS FROM EMAILJS DASHBOARD
      const serviceID = 'service_ydikdei'; 
      const templateID = 'template_9hyper2';
      const publicKey = 'Ryz61QN6Q-4t5i4r7';

      // We pass formData directly. Make sure your EmailJS template uses {{name}}, {{destination}}, etc.
      await emailjs.send(serviceID, templateID, formData, publicKey);
      
      // Success
      setIsModalOpen(true);
      
      setFormData({ destination: '', date: '', travelers: 1, name: '', email: '', phone: '' });
      
      setTimeout(() => {
        setIsModalOpen(false);
        navigate('/');
      }, 3000);

    } catch (error) {
      console.error("Booking Error:", error);
      // Even if email fails, if DB worked, we consider it a success for the user, 
      // but maybe show a warning log
      setErrors({ submit: 'Booking saved. Confirmation email might be delayed.' });
      setIsModalOpen(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="book-now-container">
      <h2>Book Your Next Adventure</h2>
      <form onSubmit={handleSubmit} className="booking-form">
        {errors.submit && <div className="error-message global">{errors.submit}</div>}
        
        <div className="form-group">
          <label htmlFor="destination">Destination</label>
          <input type="text" name="destination" value={formData.destination} onChange={handleChange} required placeholder="Where do you want to go?"/>
        </div>
        
        <div className="form-group">
          <label htmlFor="date">Travel Date</label>
          <input type="date" name="date" value={formData.date} onChange={handleChange} required />
        </div>

        <div className="form-group">
          <label htmlFor="travelers">Travelers</label>
          <input type="number" name="travelers" min="1" value={formData.travelers} onChange={handleChange} required />
        </div>

        <div className="form-group">
          <label htmlFor="name">Full Name</label>
          <input type="text" name="name" value={formData.name} onChange={handleChange} required />
        </div>

        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input type="email" name="email" value={formData.email} onChange={handleChange} required />
        </div>

        <div className="form-group">
          <label htmlFor="phone">Phone Number</label>
          <input type="tel" name="phone" value={formData.phone} onChange={handleChange} required />
        </div>

        <button type="submit" className="submit-button" disabled={isSubmitting}>
          {isSubmitting ? 'Sending Request...' : 'Book Now'}
        </button>
      </form>

      {isModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Booking Sent!</h3>
            <p>We have received your request. We will contact you at {formData.email} shortly.</p>
            <div className="modal-icon">✓</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BookNow;